import { defaultConfig } from "./settings"
import Alert from "./alert"

export default new Alert(defaultConfig)
